export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-accent-50">
      <div className="px-6 md:px-12 max-w-3xl mx-auto text-center">
        <p className="text-xs md:text-sm font-medium text-accent-600 uppercase tracking-wider mb-6">
          Why Use Superbuy Spreadsheet?
        </p>
        <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
          A <strong className="text-foreground-900">superbuy spreadsheet</strong> is the ultimate tool for smart shoppers who want to discover the best finds,
          compare prices across hundreds of sellers, and save money on every purchase. Our curated spreadsheets bring together
          hand-picked products, verified seller ratings, and real QC photos so you never have to guess whether a product is
          worth buying. Whether you are hunting for rare sneakers, premium streetwear, luxury accessories, or everyday essentials,
          the right <strong className="text-foreground-900">superbuy spreadsheet</strong> transforms hours of browsing into a streamlined,
          confidence-boosting shopping experience. Join thousands of savvy shoppers who already rely on our data to make informed
          decisions and score incredible deals every single day.
        </p>
        <p className="mt-6 text-2xl">✨</p>
      </div>
    </section>
  );
}